(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabObjectTypes', TabObjectTypes);

    TabObjectTypes.$inject = ['$resource'];

    function TabObjectTypes($resource) {
        var resourceUrl = 'api/tab-object-types/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'filterType': {
                url: 'api/tab-object-types/filterClass/:className',
                method: 'GET',
                isArray: true
            },
            'byFleet': {
                url: 'api/tab-object-types/by-fleet/:id',
                method: 'GET',
                isArray: true
            },
            'mapped': {
                url: 'api/tab-object-types/mapped',
                method: 'GET'
            },
            'getTemplate': {
                url: 'api/tab-object-types/mapping/:id',
                method: 'GET'
            },
            'putTemplate': {
                url: 'api/tab-object-types/mapping/new',
                method: 'PUT'
            },
            'getMapping': {
                url: 'api/tab-object-types/template-mapping/:id',
                method: 'GET'
            },
            'getMappingByIndex': {
                url: 'api/tab-object-types/template-mapping-index/:id',
                method: 'GET'
            },
            'newInObject': {
                url: 'api/tab-object-types/mapping/new-in-object',
                method: 'PUT'
            },
            'delete': {
                url: 'api/tab-object-types/:id/:decision',
                method: 'DELETE'
            }
        });
    }
})();
